import React from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Divider,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={2} sx={{ p: 4, mt: 6 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          Privacy Policy
        </Typography>

        <Typography variant="body1" paragraph>
          Last updated: {new Date().toLocaleDateString()}
        </Typography>

        <Divider sx={{ my: 3 }} />

        <Typography variant="h5" gutterBottom>
          Introduction
        </Typography>
        <Typography variant="body1" paragraph>
          This Privacy Policy describes how Nordic Clinical Trials Transparency
          ("we", "our", or "us") collects, uses, and protects your information
          when you use our website and services.
        </Typography>

        <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
          Information We Collect
        </Typography>
        <Typography variant="body1" paragraph>
          We collect minimal information to improve your experience:
        </Typography>
        <List sx={{ listStyleType: "disc", pl: 2 }}>
          <ListItem sx={{ display: "list-item", pl: 1 }}>
            <ListItemText
              primary="Usage Analytics"
              secondary="We use Google Analytics to understand how visitors use our website. This includes information about pages visited, time spent on site, and general location data (country/region level only)."
            />
          </ListItem>
          <ListItem sx={{ display: "list-item", pl: 1 }}>
            <ListItemText
              primary="Cookie Preferences"
              secondary="We store your cookie consent preference locally on your device to remember your choice."
            />
          </ListItem>
        </List>

        <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
          How We Use Your Information
        </Typography>
        <Typography variant="body1" paragraph>
          The information we collect is used to:
        </Typography>
        <List sx={{ listStyleType: "disc", pl: 2 }}>
          <ListItem sx={{ display: "list-item", pl: 1 }}>
            <ListItemText primary="Improve website functionality and user experience" />
          </ListItem>
          <ListItem sx={{ display: "list-item", pl: 1 }}>
            <ListItemText primary="Analyze website traffic and usage patterns" />
          </ListItem>
          <ListItem sx={{ display: "list-item", pl: 1 }}>
            <ListItemText primary="Remember your cookie preferences" />
          </ListItem>
        </List>

        <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
          Google Analytics
        </Typography>
        <Typography variant="body1" paragraph>
          We use Google Analytics to understand how our website is used. Google
          Analytics:
        </Typography>
        <List sx={{ listStyleType: "disc", pl: 2 }}>
          <ListItem sx={{ display: "list-item", pl: 1 }}>
            <ListItemText primary="Only collects data if you accept cookies" />
          </ListItem>
          <ListItem sx={{ display: "list-item", pl: 1 }}>
            <ListItemText primary="Uses anonymized IP addresses" />
          </ListItem>
          <ListItem sx={{ display: "list-item", pl: 1 }}>
            <ListItemText primary="Does not collect personal information" />
          </ListItem>
          <ListItem sx={{ display: "list-item", pl: 1 }}>
            <ListItemText primary="Can be disabled by declining cookies" />
          </ListItem>
        </List>

        <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
          Data Storage and Security
        </Typography>
        <Typography variant="body1" paragraph>
          We do not store personal information on our servers. All data is:
        </Typography>
        <List sx={{ listStyleType: "disc", pl: 2 }}>
          <ListItem sx={{ display: "list-item", pl: 1 }}>
            <ListItemText primary="Stored locally on your device (cookie preferences)" />
          </ListItem>
          <ListItem sx={{ display: "list-item", pl: 1 }}>
            <ListItemText primary="Processed by Google Analytics (if accepted)" />
          </ListItem>
          <ListItem sx={{ display: "list-item", pl: 1 }}>
            <ListItemText primary="Never shared with third parties except Google Analytics" />
          </ListItem>
        </List>

        <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
          Your Rights
        </Typography>
        <Typography variant="body1" paragraph>
          You have the right to:
        </Typography>
        <List sx={{ listStyleType: "disc", pl: 2 }}>
          <ListItem sx={{ display: "list-item", pl: 1 }}>
            <ListItemText primary="Decline cookies and analytics tracking" />
          </ListItem>
          <ListItem sx={{ display: "list-item", pl: 1 }}>
            <ListItemText primary="Change your cookie preferences at any time" />
          </ListItem>
        </List>

        <Typography variant="h5" gutterBottom sx={{ mt: 3 }}>
          Changes to This Policy
        </Typography>
        <Typography variant="body1" paragraph>
          We may update this Privacy Policy from time to time. We will notify
          users of any material changes by updating the "Last updated" date at
          the top of this page.
        </Typography>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;
